var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIconRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bttn_Remove"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#B4B7B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2143 9.28571C14.1827 9.28571 14.1525 9.29826 14.1301 9.32058C14.1078 9.34291 14.0953 9.37319 14.0953 9.40476V11.0476H17.381V9.40476C17.381 9.37319 17.3684 9.34291 17.3461 9.32058C17.3238 9.29826 17.2935 9.28571 17.2619 9.28571H14.2143ZM18.6667 11.0476V9.40476C18.6667 9.0322 18.5187 8.67489 18.2552 8.41145C17.9918 8.148 17.6345 8 17.2619 8H14.2143C13.8417 8 13.4844 8.148 13.221 8.41145C12.9575 8.67489 12.8095 9.0322 12.8095 9.40476V11.0476H10.4123C10.4078 11.0476 10.4033 11.0476 10.3987 11.0476H9.64286C9.28782 11.0476 9 11.3354 9 11.6905C9 12.0455 9.28782 12.3333 9.64286 12.3333H9.81331L10.5241 20.8624C10.5316 21.4265 10.759 21.9659 11.1585 22.3654C11.5648 22.7717 12.1159 23 12.6905 23H18.7857C19.3604 23 19.9115 22.7717 20.3178 22.3654C20.7173 21.9659 20.9446 21.4265 20.9522 20.8624L21.663 12.3333H21.8333C22.1883 12.3333 22.4761 12.0455 22.4761 11.6905C22.4761 11.3354 22.1883 11.0476 21.8333 11.0476H21.0775C21.073 11.0476 21.0685 11.0476 21.0639 11.0476H18.6667ZM18.0205 12.3333C18.0216 12.3333 18.0227 12.3333 18.0238 12.3333C18.0249 12.3333 18.0261 12.3333 18.0272 12.3333H20.3728L19.6689 20.7799C19.6674 20.7977 19.6667 20.8155 19.6667 20.8333C19.6667 21.067 19.5739 21.291 19.4087 21.4563C19.2435 21.6215 19.0194 21.7143 18.7857 21.7143H12.6905C12.4569 21.7143 12.2328 21.6215 12.0676 21.4563C11.9024 21.291 11.8096 21.067 11.8096 20.8333C11.8096 20.8155 11.8088 20.7977 11.8074 20.7799L11.1035 12.3333H13.449C13.4502 12.3333 13.4513 12.3333 13.4524 12.3333C13.4535 12.3333 13.4546 12.3333 13.4558 12.3333H18.0205ZM14.2143 14.0953C14.5693 14.0953 14.8571 14.3831 14.8571 14.7381V19.3095C14.8571 19.6646 14.5693 19.9524 14.2143 19.9524C13.8592 19.9524 13.5714 19.6646 13.5714 19.3095V14.7381C13.5714 14.3831 13.8592 14.0953 14.2143 14.0953ZM17.2619 14.0953C17.617 14.0953 17.9048 14.3831 17.9048 14.7381V19.3095C17.9048 19.6646 17.617 19.9524 17.2619 19.9524C16.9069 19.9524 16.6191 19.6646 16.6191 19.3095V14.7381C16.6191 14.3831 16.9069 14.0953 17.2619 14.0953Z",
    fill: "#DD0404"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIconRemove);
export default __webpack_public_path__ + "static/media/new_icon_remove.a3fd46beea6e5f1be99178ed441cc44b.svg";
export { ForwardRef as ReactComponent };